import { type FunctionComponent, useRef } from 'react';
import { ViewIds } from '@ardoq/api-types';
import { connect } from '@ardoq/rxbeach';
import { toViewpointModeMainViewInstanceId } from 'appLayout/mainViewInstanceIds';
import { getViewpointModeViewSettingsWithChanges$ } from 'views/environmentals/viewSettings/viewpointModeViewSettings$';
import { SunburstVisualization } from '../view/sunburst/SunburstVisualization';
import { HierarchicalViewpointShell } from './HierarchicalViewpointShell';
import { getViewpointViewModel$ } from './viewpointViewModel$';
import type { HierarchicalViewpointViewProperties } from './types';

const VIEW_ID = ViewIds.SUNBURST;
const VIEW_INSTANCE_ID = toViewpointModeMainViewInstanceId(VIEW_ID);

/** The sunburst in viewpoint mode. See {@link HierarchicalTreemapViewpointView}. */
const SunburstViewpointView = (props: HierarchicalViewpointViewProperties) => {
  const {
    sizedNodes,
    viewSettings: { maxDepth },
    formatValue,
  } = props;
  const viewContainer = useRef<HTMLDivElement>(null);

  return (
    <HierarchicalViewpointShell
      viewId={ViewIds.SUNBURST}
      properties={props}
      viewContainer={viewContainer}
    >
      <SunburstVisualization
        sizedNodes={sizedNodes}
        maxDepth={maxDepth}
        formatValue={formatValue}
        viewContainer={viewContainer}
        i18nLocale={props.i18nLocale}
      />
    </HierarchicalViewpointShell>
  );
};

const ConnectedSunburstViewpointView: FunctionComponent = connect(
  SunburstViewpointView,
  getViewpointViewModel$({
    viewId: VIEW_ID,
    viewInstanceId: VIEW_INSTANCE_ID,
    viewSettingsWithChanges$: getViewpointModeViewSettingsWithChanges$(
      VIEW_ID,
      VIEW_INSTANCE_ID
    ),
  })
);

export { SunburstViewpointView, ConnectedSunburstViewpointView };
